<template>
  <div class="admin-actions">
    <PageHeader>
      <div class="heading">
        <h1>
          Admin Actions
        </h1>
      </div>
    </PageHeader>

    <div class="page-columns">
      <div class="col main">
        <div class="page-content">
          <ul class="actions-list">
            <li>
              <Sprite name="list-gallery"/>
              <p><router-link :to="{name: 'admin-gallery'}">Gallery Image Importer</router-link></p>
            </li>
            <li>
              <Sprite name="list-reviews"/>
              <p><router-link :to="{name: 'admin-reviews'}">Reviews Importer</router-link></p>
            </li>
            <li>
              <Sprite name="pages"/>
              <p><router-link :to="{name: 'admin-pages'}">Bulk Page Creator</router-link></p>
            </li>
            <li>
              <Sprite name="logo"/>
              <p><router-link :to="{name: 'admin-certificate'}">Generate New Certificate</router-link></p>
            </li>
            <li>
              <Sprite name="pages"/>
              <p><router-link :to="{name: 'admin-images-backup'}">Replace List Item Images (temporary)</router-link></p>
            </li>
            <li>
              <Sprite name="company"/>
              <p><router-link :to="{name: 'admin-replace-templates'}">Import templates (temporary)</router-link></p>
            </li>
          </ul>
        </div>
      </div>

      <div class="col side">
        <PageSummary>
          <div>
            <h1>Admin Actions</h1>
            <p>
              This section allows the admin to perform various automated tasks, such as creating a new company, website and page content.
            </p>
          </div>
        </PageSummary>
      </div>
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import PageHeader from '@/components/PageHeader'
import PageSummary from '@/components/PageSummary'
import Sprite from '@/components/Sprite'

export default {
  name: 'admin-actions',

  data() {
    return {
      title: 'Admin Actions'
    }
  },

  mixins: [page],

  components: {
    PageHeader,
    PageSummary,
    Sprite
  }
}
</script>

<style lang="sass">
@import '../stylesheets/base/variables'
@import '../stylesheets/base/theme'
@import '../stylesheets/helpers/mixins'
@import '../stylesheets/helpers/extends'

.admin-actions
  @extend %page

  .actions-list
    list-style: none
    padding: 0

    li
      display: flex
      align-items: center
      padding: $gap-x-small 0

    .sprite
      width: 30px
      height: 30px
      margin-right: $gap-small

      @include themify($themes)
        fill: themed('color-primary')
</style>
